import { render, staticRenderFns } from "./ToiletDeleteScreen.vue?vue&type=template&id=5a48122e&scoped=true&lang=pug"
import script from "./ToiletDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./ToiletDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./ToiletDeleteScreen.vue?vue&type=style&index=0&id=5a48122e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48122e",
  null
  
)

export default component.exports